import type { PredictionContract } from "@/schemas";

export const isThreeWayDrawContract = (contract: PredictionContract): boolean =>
  contract.type === "Moneyline (3-Way)" && contract.title === "Draw";

export const sortPredictionContracts = (
  contracts: PredictionContract[],
): PredictionContract[] => {
  if (!contracts.some((contract) => contract.type === "Moneyline (3-Way)")) {
    return contracts;
  }

  const drawContract = contracts.find(isThreeWayDrawContract);
  if (!drawContract) return contracts;

  const remainingContracts = contracts.filter(
    (contract) => contract.id !== drawContract.id,
  );

  return [
    remainingContracts[0],
    drawContract,
    ...remainingContracts.slice(1),
  ].filter(Boolean) as PredictionContract[];
};
